import { deletePrivatebenchmarkId } from "api/admin/src";
import { useMutation } from "redux-query-react";
export const optimisticUpdateForDelete = (ids) => ({
    PrivateBenchmarks: (prevValue) => {
        const optimisticValue = { ...prevValue };
        ids.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    }
});
export const rollbackForDelete = (ids) => ({
    PrivateBenchmarks: (initialValue, currentValue) => {
        const rollbackValue = { ...currentValue };
        ids.forEach((id) => {
            rollbackValue[id] = initialValue[id];
        });
        return rollbackValue;
    }
});
export const updateForDelete = (ids) => ({
    PrivateBenchmarks: (prevValue) => {
        const updateValue = { ...prevValue };
        ids.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    }
});
export const useDeleteBenchmark = () => useMutation((request) => {
    const customQueryConfig1 = {
        optimisticUpdate: optimisticUpdateForDelete([request.id]),
        rollback: rollbackForDelete([request.id]),
        update: updateForDelete([request.id])
    };
    return deletePrivatebenchmarkId(request, { ...customQueryConfig1 });
});
